import { Device } from '@twilio/voice-sdk';
import { useEffect, useMemo, useState } from 'react';
import ImgHolder from '../../components/imgHolder';
import icHangUp from "../../assets/images/hangup.svg";
import icMicEnable from "../../assets/images/mic_enable.png";
import icMicDisable from "../../assets/images/mic_disable.png";
import { padWithZero } from '../../helpers/utility';
import { useGetCallStatusQuery, useGetTwilioTokenQuery } from '../../services/twilioService';
import { useGroupChatContext } from '../../context/groupchatContext';
import closeIcon from "../../assets/images/close_icon.png";
import minimizeIcon from "../../assets/images/minimize_icon.png";
import maximizeIcon from "../../assets/images/maximize_icon.png";
import handIcon from "../../assets/images/dwtImages/Hand.png"

const TwilioDialer = ({closeHandler}) => {

    const [device, setDevice] = useState(null);
    const [callInstant, setCallInstant] = useState(null);
    const [callTime, setCallTime] = useState({hours: '00', minutes: '00', seconds: '00'})
    const callStartTime = Date.now();
    const [callMinimize, setCallMinimize] = useState(false);
    const [position, setPosition] = useState({ x: 100, y: 50 });
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);


    const groupChatContext = useGroupChatContext();
    const { authData, selectedChat, callData, setCallData } = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
        callData: groupChatContext.callData,
        setCallData: groupChatContext.setCallData,
    }));

    const {data: twilioToken} = useGetTwilioTokenQuery();
    const {data: callStatus, refetch: refetchCallStatus} = useGetCallStatusQuery({call_sid: callData?.call_sid}, {skip: !callData?.call_sid});
   
    useEffect(()=>{
        if(twilioToken?.token){
            const twilioDevice = new Device(twilioToken.token);
            twilioDevice.on('ready', () => {
                console.log('Twilio Device is ready for calls');
            });

            twilioDevice.on('error', (error) => {
                console.error('Twilio Device error:', error);
            });

            twilioDevice.on('tokenWillExpire', () => {
                console.error('Twilio token expired');
            });

            twilioDevice.on('incoming', call => {
                console.log("Incoming Call: ", call)
            });

            twilioDevice.on('offline', deviceObj => {
                console.warn("Device is offline")
            })

            twilioDevice.on('ready', deviceObj =>{
                console.log("Device Ready");
            })

            // twilioDevice.addListener('registered', deviceObj => {
            //     console.log('The device is ready to receive incoming calls.')
            //     // makeOutgoingCall(twilioDevice);
            // });

            setDevice(twilioDevice);

            return () => {
                if(twilioDevice) {
                    twilioDevice.destroy();
                }
            };
        }
    }, [twilioToken])

    const makeOutgoingCall = () => {
        if(device){
            const params = { To: '+14046881350', locationId: selectedChat?.location.id, practiceId: authData?.practice?.id,
            pid: selectedChat?.pid, chatId: selectedChat?.chat_id, nurseId: authData.nurse_id};
            device.connect({params}).then((call)=>{
                setCallInstant(call);
                call.on('ringing', () => {
                    setCallData({call_sid: call.parameters.CallSid}); // setting call sid here. Because its available once call start ringing
                });

                call.on('disconnect', item => {
                    console.log("Call disconnected")
                    disconnectCall()
                })
            })
        }
    };

    useEffect(() => {
        if(callStatus){
            const callStatusIntervalId = setInterval(() => {
                refetchCallStatus()
                if (callStatus?.msg === 'call started') {
                    startCallTimer();
                }
            }, 1000);
        
            return () => clearInterval(callStatusIntervalId);
        }
    }, [callStatus]);


    useEffect(()=>{
        if(device){
            makeOutgoingCall()
        }
    }, [device])

    const disconnectCall = () => {
        device.disconnectAll();
        setCallData(null)
        closeHandler()
    }

    const handleMuteUnmute = () => {
        if(!callInstant.isMuted()){
            callInstant.mute(true);
        }
        else{
            callInstant.mute(false);
        } 
    }

    const startCallTimer = () => {
        let callIntervalId;
        callIntervalId = setInterval(() => {
            const now = Date.now();
            const diff = now - callStartTime;
            const hours = Math.floor(diff / 3600000);
            const minutes = Math.floor((diff % 3600000) / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);

            setCallTime({ hours: padWithZero(hours), minutes: padWithZero(minutes), seconds: padWithZero(seconds) });
        }, 1000);

        return () => {
            if(callIntervalId){
                clearInterval(callIntervalId);
            }
        };
    }

    const handleMouseMove = (e) => {
        if(isDragging) {
            setPosition({
                x: e.clientX - offset.x,
                y: Math.max(e.clientY - offset.y, 10) //Ensures that the y position cannot go below 10. Prevents the window from being dragged so far up that the top buttons (like close, minimize, maximize) become hidden off-screen.
            });
        }
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        if (isDragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
        } else {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        }

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isDragging]);

    const resizeCallWindow = () => {
        setCallMinimize(!callMinimize);
    }


    return (
        <div className={`rounded-xl border border-gray-200 bg-white p-1 absolute w-56 ${callMinimize ? 'h-[50px]' : 'bottom-20 h-[325px]' }`}
            style={{ zIndex: 1000, top: position.y, left: position.x, visibility: 'visible', position: 'fixed' }} 
        >
            <img src={callMinimize ? maximizeIcon : minimizeIcon} className="w-6 h-6 absolute border border-black p-1 top-[-1.5rem] right-[0.5rem] bg-white cursor-pointer" style={{ zIndex: 1001 }} onClick={resizeCallWindow}/>
            <img src={handIcon} className="w-6 h-6 absolute border border-black p-1 top-[-1.5rem] right-[2.5rem] bg-gray-200 cursor-move" style={{ zIndex: 1001, userSelect: 'none' }}
                onMouseDown={handleMouseDown}
            />

            {callMinimize ?
                <div className='text-center'>
                    <div className="flex justify-center mt-2">
                        <h3 className="text-base italic">Calling via ethizo</h3>
                    </div>
                </div>
                :
                <div className={`text-center`}>
                    <div className="flex justify-center my-4 ">
                        <div className='h-14 w-14'>
                            <ImgHolder uuid='male' />
                        </div>
                    </div>

                    {/* <div className={`flex justify-center mt-0`}>
                        <h3 className="text-xl">
                            {callData.call_number}
                        </h3>
                    </div> */}

                    <div className="flex justify-center mt-4">
                        <h3 className="text-base italic">Calling via ethizo</h3>
                    </div>

                    {/* Call Timer*/}
                    <div
                        className="flex justify-center mt-8"
                    >
                        <h3 className="text-xl">
                            <span>{callTime.hours}</span>:<span>{callTime.minutes}</span>:<span>{callTime.seconds}</span>
                        </h3>
                    </div>

                    {/* Hangup Button */}
                    <div className="flex justify-center mt-4">
                        <button
                            className="bg-red-600 text-white rounded-full h-12 w-12 p-2"
                            onClick={disconnectCall}
                        >
                            <img src={icHangUp} alt="Hangup" />
                        </button>
                    </div>

                    {/* Mute/Unmute Buttons */}
                    <div className="flex justify-center mt-6">
                        <button
                            className="bg-gray-800 rounded-full h-12 w-12 p-2"
                            onClick={handleMuteUnmute}
                        >
                            <img src={callInstant?.isMuted() ? icMicDisable : icMicEnable} alt="Hangup" />
                        </button>
                    </div>
                </div>
            }
        </div>
    )
}

export default TwilioDialer
